var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.24064,0,0,1.24064,-69.614,-67.7717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-37"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.62,
    cy: 392.44,
    rx: 198.52,
    ry: 10.83,
    style: {
      fill: "rgb(15,152,247)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.62,
    cy: 392.44,
    rx: 198.52,
    ry: 10.83,
    style: {
      fill: "white",
      fillOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.64,115.384C365.64,111.86 362.78,109 359.256,109L249.344,109C245.82,109 242.96,111.86 242.96,115.384L242.96,380.636C242.96,384.16 245.82,387.02 249.344,387.02L359.256,387.02C362.78,387.02 365.64,384.16 365.64,380.636L365.64,115.384Z",
    style: {
      fill: "white",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.54,157.67C360.646,157.67 359.91,156.934 359.91,156.04L359.91,134.19C359.976,133.341 360.694,132.678 361.545,132.678C362.396,132.678 363.114,133.341 363.18,134.19L363.18,156C363.18,156.01 363.18,156.02 363.18,156.03C363.18,156.93 362.44,157.67 361.54,157.67C361.54,157.67 361.54,157.67 361.54,157.67Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.54,177.91C360.646,177.91 359.91,177.174 359.91,176.28L359.91,164.07C359.976,163.221 360.694,162.558 361.545,162.558C362.396,162.558 363.114,163.221 363.18,164.07L363.18,176.28C363.175,177.176 362.436,177.91 361.54,177.91Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.39,115.384C356.39,111.86 353.53,109 350.006,109L240.094,109C236.57,109 233.71,111.86 233.71,115.384L233.71,380.636C233.71,384.16 236.57,387.02 240.094,387.02L350.006,387.02C353.53,387.02 356.39,384.16 356.39,380.636L356.39,115.384Z",
    style: {
      fill: "rgb(38,50,56)",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.88,
    y: 127.51,
    width: 106.34,
    height: 238.46,
    style: {
      fill: "rgb(15,152,247)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.26,119.89L307.57,119.89",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.24,374.41C291.24,376.36 290.02,377.94 288.51,377.94C287,377.94 285.79,376.36 285.79,374.41C285.79,372.46 287.01,370.87 288.51,370.87C290.01,370.87 291.24,372.45 291.24,374.41Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.05,
    cy: 165.35,
    rx: 18.44,
    ry: 21.5,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.05,
    cy: 156.91,
    rx: 7,
    ry: 8.17,
    style: {
      fill: "rgb(38,50,56)",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.05,167.25C288.05,167.25 282.32,172.62 282.32,179.25C282.326,179.867 282.382,180.482 282.49,181.09C285.631,184.755 290.223,186.868 295.05,186.868C299.877,186.868 304.469,184.755 307.61,181.09C307.709,180.482 307.763,179.866 307.77,179.25C307.77,172.62 302.07,167.25 295.05,167.25Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.47,259L272.63,259C270.175,258.903 268.235,256.805 268.33,254.35L268.33,226.67C268.33,210.72 280.33,197.74 295.05,197.74C309.77,197.74 321.76,210.74 321.76,226.67L321.76,254.33C321.763,254.395 321.764,254.459 321.764,254.524C321.764,256.911 319.856,258.901 317.47,259ZM276.92,249.7L313.17,249.7L313.17,226.7C313.17,215.88 305.04,207.07 295.05,207.07C285.06,207.07 276.92,215.88 276.92,226.7L276.92,249.7Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.92,
    y: 240.11,
    width: 62.26,
    height: 58.9,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.12,280.66L299.5,269.55C301.57,267.985 302.778,265.525 302.75,262.93C302.75,258.5 299.44,254.93 295.35,254.93C291.26,254.93 287.96,258.51 287.96,262.93C287.928,265.524 289.132,267.984 291.2,269.55L286.59,280.66L304.12,280.66Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.08,351.94C276.176,352.01 276.291,352.049 276.41,352.05C276.582,352.049 276.744,351.963 276.84,351.82L348.22,254.73L348.22,252.89L276,351.18C275.922,351.276 275.879,351.396 275.879,351.52C275.879,351.683 275.953,351.838 276.08,351.94Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.86,162.49C333.791,162.583 333.754,162.695 333.754,162.811C333.754,162.985 333.838,163.149 333.98,163.25C334.222,163.422 334.563,163.369 334.74,163.13L348.22,144.8L348.22,143L333.86,162.49Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.88,289.46L330,169.63C330.068,169.537 330.104,169.425 330.104,169.31C330.104,169.012 329.858,168.766 329.56,168.766C329.386,168.766 329.222,168.849 329.12,168.99L241.92,287.62L241.88,289.46Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.8,363.76C267.972,363.757 268.134,363.676 268.24,363.54L273.24,356.78C273.309,356.687 273.346,356.575 273.346,356.459C273.346,356.285 273.262,356.121 273.12,356.02C272.878,355.848 272.537,355.901 272.36,356.14L267.36,362.89C267.289,362.984 267.251,363.098 267.251,363.216C267.251,363.387 267.332,363.548 267.47,363.65C267.564,363.724 267.681,363.763 267.8,363.76Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.22,274.17L289.62,353.88C289.552,353.973 289.515,354.085 289.515,354.2C289.515,354.496 289.759,354.74 290.055,354.74C290.057,354.74 290.058,354.74 290.06,354.74C290.234,354.743 290.398,354.661 290.5,354.52L348.22,276L348.22,274.17Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.41,162.14C143.401,159.943 143.88,157.549 143.81,155.14C143.81,150.67 138.4,148.08 132.04,147.37C125.68,146.66 122.86,149.25 123.8,150.9C124.777,152.261 125.969,153.453 127.33,154.43C128.691,155.407 120.97,150.9 116.73,153.73C112.49,156.56 118.62,155.38 117.44,158.2C116.26,161.02 109.67,159.85 108.02,167.38C106.37,174.91 111.08,182.45 106.84,185.75C102.6,189.05 89.84,184.57 86.12,192.81C82.4,201.05 87.68,204.71 78.74,209.89C69.8,215.07 63.28,220.13 65.87,232.84C68.46,245.55 76.94,250 93.66,245.51C110.38,241.02 109.2,230.91 114.66,220.51C120.12,210.11 128.56,212.27 131.15,206.38C133.74,200.49 130.44,193.43 130.68,188.01C130.92,182.59 136.33,181.42 138.45,175.01C140.57,168.6 142.41,162.14 142.41,162.14Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.82,232.6C67.381,233.485 67.159,234.462 67.17,235.45",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.37,157.47C133.37,157.47 130.43,154.07 136.09,155.65C143.22,157.65 134.85,165.9 131.63,167.56C125.17,170.87 116.63,169.81 111.63,175.83C107.09,181.27 113.22,186.94 110.5,191.25C107.78,195.56 96.89,193.06 93.27,198.25C89.65,203.44 99.84,214.58 89.41,220.7C81.87,225.13 73.61,226.83 69.62,230.34",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.46,177.59C115.842,179.036 115.655,180.63 115.92,182.18C116.82,186.03 122.04,193.29 117.28,197.37C112.52,201.45 104.35,201.22 103,206C101.65,210.78 104.36,223.91 99.83,230C95.3,236.09 86.45,235.67 81.69,239.75C76.93,243.83 77.61,246.1 77.61,246.1",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.86,173.11C118.448,173.692 118.067,174.297 117.72,174.92",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.46,232.24L146.61,241.24C146.61,241.24 152.61,247.24 157.02,250.95C161.43,254.66 172.73,262.51 172.73,262.51L167,264.14C167,264.14 148.27,253.04 144.57,252.14C140.87,251.24 138.1,245.9 136.95,244.28C135.8,242.66 142.45,230.62 145.46,232.24Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9,378.67C156.9,378.67 162.56,383.45 164.9,385.05C167.24,386.65 169.97,387.37 169.54,388.24C169.11,389.11 167.94,389.98 162.43,389.24C156.92,388.5 155.33,386.63 154.31,386.34C153.29,386.05 150.83,386.78 148.95,385.62C147.07,384.46 150.05,377.55 150.05,377.55C151.748,379.535 154.658,380.011 156.9,378.67Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.52,388.24C169.524,388.193 169.524,388.147 169.52,388.1C166.339,388.392 163.131,388.09 160.06,387.21C156.5,386.37 155.45,384.48 152.06,384.48C150.73,384.492 149.407,384.276 148.15,383.84C148.076,384.517 148.342,385.188 148.86,385.63C150.74,386.79 153.21,386.06 154.22,386.35C155.23,386.64 156.83,388.53 162.34,389.25C167.85,389.97 169.08,389.11 169.52,388.24Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.27,185.4C127.27,185.4 128.36,192.74 126.96,195.7C125.56,198.66 121.18,198.98 117.44,199.61C113.7,200.24 105.11,203.51 106.04,211.94C106.97,220.37 117.75,238.63 117.75,243.78C117.75,248.93 114.47,251.58 110.88,261.57C107.29,271.56 107.76,290.14 108.88,302.16C109.701,310.093 111.268,317.931 113.56,325.57C115.852,333.209 104.56,340.09 100.56,346.33C96.56,352.57 82.56,379.74 82.56,379.74C82.56,379.74 82.56,380.67 84.74,381.3C86.274,381.673 87.861,381.778 89.43,381.61C90.999,381.442 116.27,349.3 121.27,343.84C126.27,338.38 130.95,328.84 131.57,324.48C132.19,320.12 131.42,293.42 131.42,293.42C131.42,293.42 137.03,306.84 141.42,313.71C144.083,317.914 146.526,322.253 148.74,326.71C148.125,332.36 148.125,338.06 148.74,343.71C149.83,351.51 148.91,376.57 150,378.6C151.09,380.63 155.32,379.78 156.26,378.85C157.2,377.92 157.64,371.85 157.64,371.85C157.64,371.85 159.51,352.85 160.64,343.91C161.77,334.97 163.64,327.36 162.99,325.33C162.34,323.3 158.46,301.6 155.49,291.33C152.52,281.06 143.49,261.83 141.49,256.84C139.49,251.85 138.36,247.31 138.68,245.75C139,244.19 145.08,234.83 146.68,232.33C148.528,228.896 148.643,224.782 146.99,221.25C145.12,217.19 146.99,211.72 146.68,208.45C146.37,205.18 141.53,203.76 139.03,202.52C136.53,201.28 135.59,198.46 135.59,196.12C135.743,194.149 136.219,192.216 137,190.4C137.781,188.584 129.3,185.4 127.27,185.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19,218.79C145.368,216.7 144.683,214.559 144.14,212.38",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.92,236.17C125.92,236.17 128.74,236.79 134.39,233.97",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.52,291.23C152.69,281.39 144.3,263.42 141.79,257.49C129.79,261.99 118.57,258.15 113.3,255.67C112.54,257.33 111.72,259.25 110.88,261.57C107.29,271.57 107.76,290.14 108.88,302.16C109.701,310.093 111.268,317.931 113.56,325.57C115.852,333.209 104.56,340.09 100.56,346.33C96.56,352.57 82.56,379.74 82.56,379.74C82.56,379.74 82.56,380.67 84.74,381.3C86.274,381.673 87.861,381.778 89.43,381.61C90.999,381.442 116.27,349.3 121.27,343.84C126.27,338.38 130.95,328.84 131.57,324.48C132.19,320.12 131.42,293.42 131.42,293.42C131.42,293.42 137.03,306.84 141.42,313.71C144.083,317.914 146.526,322.253 148.74,326.71C148.125,332.36 148.125,338.06 148.74,343.71C149.83,351.51 148.91,376.57 150,378.6C151.09,380.63 155.32,379.78 156.26,378.85C157.2,377.92 157.64,371.85 157.64,371.85C157.64,371.85 159.51,352.85 160.64,343.91C161.77,334.97 163.64,327.36 162.99,325.33C162.34,323.3 158.49,301.53 155.52,291.23Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.66,281.32L216.66,279.28L218.37,279.28L218.37,263.26L198.07,263.26L198.07,279.28L199.78,279.28L199.78,281.32L198.06,281.32L198.06,285.04L204.65,285.04L204.65,283.79L211.79,283.79L211.79,285.04L218.38,285.04L218.38,281.32L216.66,281.32Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.56,258.47L225.32,258.47C226.296,258.47 227.1,259.274 227.1,260.25L227.1,263.83C227.1,264.806 226.296,265.61 225.32,265.61L107.56,265.61L107.56,258.46L107.56,258.47Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.07,258.198C193.07,257.758 192.712,257.4 192.272,257.4L184.718,257.4C184.278,257.4 183.92,257.758 183.92,258.198L183.92,265.892C183.92,266.332 184.278,266.69 184.718,266.69L192.272,266.69C192.712,266.69 193.07,266.332 193.07,265.892L193.07,258.198Z",
    style: {
      fill: "rgb(15,152,247)",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.161604,-0.986856,0.986856,0.161604,-180.71,311.38)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.9,
    cy: 262.04,
    r: 18.59,
    style: {
      fill: "rgb(15,152,247)",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.72,262C98.914,260.949 100.342,258.752 100.41,256.32C100.41,252.67 97.05,249.71 92.9,249.71C88.75,249.71 85.39,252.71 85.39,256.32C85.454,258.753 86.883,260.953 89.08,262C86.884,263.054 85.457,265.255 85.39,267.69C85.39,271.34 88.75,274.3 92.9,274.3C97.05,274.3 100.41,271.3 100.41,267.69C100.339,265.257 98.912,263.058 96.72,262Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.06,265.77C169.06,265.77 174.88,268.23 176.68,268.23C178.48,268.23 180.56,266.42 181.59,264.23C182.62,262.04 182.59,261 181.98,261.52L180.69,262.52C180.69,262.52 181.69,260.33 180.56,260.59C179.778,260.851 179.128,261.407 178.75,262.14C178.372,262.873 178.62,260.2 177.59,261.14C176.908,261.757 176.301,262.452 175.78,263.21C175.259,263.968 175.65,260.76 175,261.4C174.35,262.04 171.91,265.53 171.91,265.53L169.06,265.77Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.78,263.19C175.78,263.19 175.39,266.29 173.46,266.81",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.75,262.16C178.75,262.16 177.75,267.06 176.17,267.84",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.69,262.54C180.174,264.328 179.481,266.06 178.62,267.71",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.66,202.22C136.614,200.839 135.43,198.486 135.54,196.02C135.719,194.08 136.212,192.182 137,190.4C137.788,188.618 129.35,185.4 127.32,185.4C127.32,185.4 128.41,192.74 127.01,195.7C126.551,196.621 125.803,197.366 124.88,197.82C126.729,202.798 129.234,207.506 132.33,211.82C135.14,215.35 136.51,207.91 138.66,202.22Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,200.62C111.184,201.28 107.847,203.724 106.05,207.21C102.97,213.15 89.51,240.11 90.66,241.72C97.2,250.92 120.99,257.54 123.41,259.96C125.829,262.491 128.485,264.784 131.34,266.81C133.76,268.35 138.59,267.69 139.47,267.25C140.35,266.81 141.01,264.83 139.47,264.83C138.262,264.846 137.198,264.008 136.93,262.83C136.71,261.95 139.35,263.71 140.67,263.05C141.99,262.39 137.72,259.98 136.4,258.88C135.08,257.78 133.98,256.25 132.22,256.25L127.15,256.25C127.15,256.25 119.05,250.38 114.15,246.01C110.337,242.57 106.178,239.533 101.74,236.95L116.59,212.52",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.39,258.89C135.07,257.79 133.97,256.26 132.21,256.26L127.14,256.26C127.14,256.26 119.04,250.39 114.14,246.02C110.327,242.58 106.168,239.543 101.73,236.96L107.67,227.18C104.633,225.342 101.159,224.351 97.61,224.31C93.61,232.65 90.02,240.89 90.61,241.76C97.15,250.96 120.94,257.58 123.36,260C125.779,262.531 128.435,264.824 131.29,266.85C133.71,268.39 138.54,267.73 139.42,267.29C140.3,266.85 140.96,264.87 139.42,264.87C138.212,264.886 137.148,264.048 136.88,262.87C136.66,261.99 139.3,263.75 140.62,263.09C141.94,262.43 137.71,260 136.39,258.89Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.44,174.63C143.66,173.07 143.66,171.82 143.97,169.63C144.28,167.44 142.41,162.13 142.41,162.13C140.5,165.43 134.98,167.39 132.54,168.13C129.85,168.95 133.78,170.81 133.36,173.3C132.94,175.79 127.57,177.23 127.57,177.23C127.57,177.23 126,174 123.82,174C121.64,174 120.09,179 121.33,181.65C121.993,183.157 123.624,184.012 125.24,183.7C126.856,183.388 125.09,188.39 128.05,189.79C131.208,191.297 134.503,192.499 137.89,193.38C139.76,193.69 141.63,192.76 142.41,189.95C143.02,187.118 143.438,184.248 143.66,181.36C144.969,180.503 146.174,179.496 147.25,178.36C148,177.28 145.22,176.19 144.44,174.63Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.4,174.7C141.4,175.56 141.12,176.25 140.78,176.25C140.44,176.25 140.16,175.56 140.16,174.7C140.16,173.84 140.44,173.15 140.78,173.15C141.12,173.15 141.4,173.84 141.4,174.7Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.71,172.12C138.71,172.12 140.37,170.25 141.61,170.67",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.61,184.94C140.087,185.399 138.429,185.018 137.26,183.94",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.63,379.74C82.63,379.74 78.9,387.22 79.04,388.24C79.18,389.26 86.58,394.62 90.04,396.5C93.5,398.38 99.76,398.68 99.32,396.07C98.88,393.46 92.94,391.72 91.49,387.8C90.718,385.772 90.05,383.706 89.49,381.61C87.073,381.646 84.694,380.998 82.63,379.74Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,396.11C96.678,396.467 93.968,396.083 91.51,395C86.14,392.67 80.94,387.91 79.51,386.56C79.256,387.099 79.094,387.677 79.03,388.27C79.18,389.27 86.57,394.65 90.03,396.53C93.49,398.41 99.7,398.67 99.34,396.11Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-37"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-37"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/log-in.250d7f86d1b0910b4804a885bdbe9963.svg";
export { ForwardRef as ReactComponent };